import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import da from "../locales/da.json";
import en from "../locales/en.json";
import hu from "../locales/hu.json";
import ja from "../locales/ja.json";
import zh_CN from "../locales/zh_cn.json";
import zh_TW from "../locales/zh_tw.json";
import messageToHalpEN from "../locales/message-to-halp.en.json";

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: (typeof resources)["en"];
  }
}

const resources = {
  da,
  en: {
    translation: {
      ...en.translation,
      ...messageToHalpEN.translation,
    },
  },
  hu,
  ja,
  zh_CN,
  zh_TW,
} as const;

export function createI18n(lng?: string) {
  const instance = i18n.createInstance({
    resources,
    fallbackLng: "en",
    lng,
  });
  instance.use(initReactI18next).init();
  return instance;
}
